import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { IoReload } from 'react-icons/io5'
import { MdAdd, MdArrowBack, MdDelete } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import Table from '../../../components/Table/Table'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import dayjs from 'dayjs'

const Contrato = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [lista, setLista] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [setDadosItem] = useState(null)

  const getList = useCallback(() => {
    metodoPrograma('lista', { idLocalAtendimento: localAtendimento[0] }).then(
      (res) => {
        if (res.status) {
          setLista(res.lista)
        }
      },
    )
  }, [localAtendimento])

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
    getList()
  }

  const exclui = (idPlano) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm(
        'Mas você tem CERTEZA que deseja excluir este local de Atendimento???',
      )
    )
      return
    await metodoPrograma('exclui', { idPlano })
    await getList()
  }

  const handleClick = (_, linha) => {
    setDados(linha)
    setTela('opcoes')
  }
  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  useEffect(() => {
    if (localAtendimento) {
      getList()
    }
  }, [localAtendimento, getList])

  return (
    <Programa codigo="CtrlContrato" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table
              dados={lista}
              head={['Plano', 'Inclusão', 'Exclusão', 'Valor', '']}
              line={(item) => [
                item[1],
                item[2] ? dayjs(item[2]).format('DD/MM/YYYY HH:MM') : null,
                item[3] ? dayjs(item[3]).format('DD/MM/YYYY HH:MM') : null,
                item[4],
                '',
              ]}
              columnOptions={[
                {
                  alias: 4,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton size="small" onClick={exclui(linhaOriginal[0])}>
                      {linhaOriginal[3] ? <IoReload /> : <MdDelete />}
                    </IconButton>
                  ),
                },
              ]}
              onClick={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela, setDadosItem }} />
      )}
    </Programa>
  )
}

export default Contrato
